<template>
    <article class="appointment-physician">
        <div class="appointment-physician__avatar">
            <common-user-avatar :user="practice" size="user-menu"></common-user-avatar>
        </div>

        <p class="appointment-physician__name">
            {{ practice.name }}
        </p>

        <template v-if="isPhoneNumberDisplayed && practice.phone">
            <p class="appointment-physician__contact">
                <common-icon-info icon="phone" size="small">
                    {{ practice.phone }}
                </common-icon-info>
            </p>
        </template>
    </article>
</template>

<script>
    export default {
        props: {
            practice: { type: Object, required: true },
            isPhoneNumberDisplayed: { type: Boolean, default: true },
        },
    }
</script>
